import React from 'react';
import InvestorInvestmentsSC from './investor-investments.styled';
import InfoBanner from '../../../components/info-banner';
import InvestorDashBanner from '../../../components/investor-dash-banner';
import ContentWrap from '../../../components/content-wrap';
import InvestorInvestmentsContent from '../../../components/investor-investments-content';

const InvestorInvestments = () => {
  return (
    <InvestorInvestmentsSC>
      <InfoBanner>
        <InvestorDashBanner />
      </InfoBanner>
      <ContentWrap>
        <InvestorInvestmentsContent />
      </ContentWrap>
    </InvestorInvestmentsSC>
  );
};

export default InvestorInvestments;
